import { Ptag } from "components/core";
import React from "react";
import AttributeInnerCard from "./AttributeInnerCard";
import { RoomRentDetailWrapper } from "./styles";

const RoomRentDetail = ({ title, data }) => {
  return (
    <section>
      <Ptag fontSize="14px" marginBottom="20px">
        {title}
      </Ptag>
      <RoomRentDetailWrapper>
        <section>
          {(data?.normal?.percentage || data?.normal?.max) && (
            <div>
              <Ptag fontSize="14px" fontWeight="600" marginBottom="18px">
                Normal Room
              </Ptag>
              <article>
                {data?.normal?.percentage && (
                  <AttributeInnerCard
                    title="Percentage of SI per day Limit"
                    value={data?.normal?.percentage + "%"}
                  />
                )}
                {data?.normal?.max && (
                  <AttributeInnerCard
                    title="Max Per Day Limit"
                    value={data?.normal?.max}
                  />
                )}
              </article>
            </div>
          )}
          {(data?.icu?.percentage || data?.icu?.max) && (
            <div>
              <Ptag fontSize="14px" fontWeight="600" marginBottom="18px">
                ICU
              </Ptag>
              <article>
                {data?.icu?.percentage && (
                  <AttributeInnerCard
                    title="Percentage of SI per day Limit"
                    value={data?.icu?.percentage + "%"}
                  />
                )}
                {data?.icu?.max && (
                  <AttributeInnerCard
                    title="Max Per Day Limit"
                    value={data?.icu?.max}
                  />
                )}
              </article>
            </div>
          )}
        </section>
        {data?.remarks && (
          <Ptag
            fontWeight="400"
            fontSize="12px"
            color="#4a4a4a"
            marginTop="14px"
          >
            Remarks: {data?.remarks}
          </Ptag>
        )}
      </RoomRentDetailWrapper>
    </section>
  );
};

function AttributeRoomRent({ data }) {
  if (data?.type === "METRO_NON_METRO") {
    return (
      <section
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "46px",
        }}
      >
        <RoomRentDetail title="Metro Cities" data={data?.values?.metro} />
        <RoomRentDetail
          title="Non-Metro Cities"
          data={data?.values?.non_metro}
        />
      </section>
    );
  }
  if (data?.type === "DEFAULT") {
    return (
      <section
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "46px",
        }}
      >
        <RoomRentDetail data={data?.values} />
      </section>
    );
  }
  return null;
}

export default AttributeRoomRent;
